export const navLinks = [
  { key: 'top', label: '首页', href: '#top' },
  { key: 'hot', label: '热门线路', href: '#hot' },
  { key: 'order', label: '观看顺序', href: '#order' },
  { key: 'zone', label: '线路分区', href: '#zone' },
  { key: 'news', label: '线路快讯', href: '#news' },
  { key: 'forum', label: '社区热议', href: '#forum' },
  { key: 'rank', label: '追更榜', href: '#rank' },
];

export const filterChips = ['全部', '流畅线路', '高清线路', '已修复', '今日更新', '补档'] as const;

export const hotRoutes = [
  { tag: '今日更新', tagClass: 'bg-orange-100 text-orange-700', line: '推荐路线', title: '《长街灯》第六季全篇上线，正序补全到最新一集', desc: '前传加五部正传再加剧场版，已按最佳路径重新排列，从第一集一口气看到结局。', meta: '更新于 09-07 21:12', steps: '全 6 部 · 无剧透', icon: 'ri-sparkling-line' },
  { tag: '流畅线路', tagClass: 'bg-teal-100 text-teal-700', line: '流畅线路', title: '《白夜回声》悬疑剧场 1080P 稳定源整理', desc: '近期更新节奏加快，把易卡顿的源替换成更稳的流畅线路，画质优先选高清。', meta: '更新于 09-07 18:40', steps: '每周二四六', icon: 'ri-speed-line' },
  { tag: '高清线路', tagClass: 'bg-rose-100 text-rose-700', line: '高清线路', title: '《夏末信笺》青春剧场开启 4K 高清线路', desc: '本季新作，全片以 4K 制作，高清线路观感最接近原片，推荐路线已置顶。', meta: '更新于 09-07 15:02', steps: '已更 6/12', icon: 'ri-hd-line' },
  { tag: '补档', tagClass: 'bg-amber-100 text-amber-700', line: '最佳路径', title: '《星海回响》拼图叙事顺序重排完成', desc: '多时间线交错，按体验最佳的顺序归档，避免第一遍就看乱时间顺序。', meta: '更新于 09-06 22:31', steps: '全 3 季', icon: 'ri-archive-line' },
  { tag: '已修复', tagClass: 'bg-emerald-100 text-emerald-700', line: '流畅线路', title: '《归途》外传线路卡顿已修复', desc: '上周频繁缓冲的几集已换源，现在流畅线路基本秒开，观感明显改善。', meta: '更新于 09-06 19:17', steps: '修复 4 处', icon: 'ri-tools-line' },
];

export const orderGuides = [
  { title: '《长街灯》宇宙 · 全剧观看顺序', series: '5 部正传 + 2 部剧场版', coverTone: 'from-orange-200 to-rose-100', count: '21 集步骤', status: '已完结', desc: '从《灯下小集》前传讲起，再到正传五部与两部剧场版，避免番外插看破坏观感。', hot: 9821 },
  { title: '《星海回响》· 拼图叙事时间线', series: '3 季交错叙事', coverTone: 'from-teal-200 to-emerald-100', count: '12 集步骤', status: '连载中', desc: '三条时间线来回跳跃，按事件发生顺序排列，第一遍也能顺着看完。', hot: 7630 },
  { title: '《归途》衍生宇宙 · 主场与支线', series: '正篇 + 外传 + 特别篇', coverTone: 'from-amber-200 to-orange-100', count: '16 集步骤', status: '已完结', desc: '衍生篇适合在正篇告一段落后插入，这份顺序保留了两版推荐路径。', hot: 5402 },
  { title: '《雾港》刑侦系列 · 一季一案', series: '6 季单元剧', coverTone: 'from-rose-200 to-pink-100', count: '9 集步骤', status: '连载中', desc: '每季独立案件可任意季开追，但季内顺序不要跳，最佳路径已标好。', hot: 3987 },
];

export const featuredOrder = {
  kicker: '本周重点 · 观看顺序',
  title: '《长街灯》到底该从哪一部开始看？',
  desc: '这份顺序表汇总了社区大部分讨论，按「无剧透 → 完整世界观 → 补剧情彩蛋」三档排列，无论你是初入坑还是补老剧，都能找到对应的最佳路径。',
  steps: ['灯下小集（前传）', '长街灯·第一部', '长街灯·第二部', '烟火往事（剧场版）', '长街灯·第三部', '巷口来客（番外）', '长街灯·终章', '月落长街（大结局）'],
  tips: ['不想被剧透结局，先避开番外中的台词彩蛋', '剧场版《烟火往事》建议在看第三部前补', '高清线路优先，长镜头画质差别最明显'],
  stats: [['累计收藏', '2.4w'], ['本周更新', '8 集'], ['争议最低', '92%']],
};

export const smoothRoutes = [
  { name: '《夏末信笺》', eps: '更新至 第 06 集', extra: '流畅线路 · 秒开稳定', quality: '高清可选', live: '在线' },
  { name: '《雾港》刑侦 第五季', eps: '更新至 第 04 集', extra: '流畅线路 · 峰值不卡', quality: '高清可选', live: '在线' },
  { name: '《白夜回声》', eps: '更新至 第 09 集', extra: '流畅线路 · 刚修复换源', quality: '高清可选', live: '在线' },
  { name: '《邻家星光》', eps: '更新至 第 11 集', extra: '流畅线路 · 备选二源', quality: '高清可选', live: '在线' },
];

export const hdRoutes = [
  { name: '《长街灯·终章》', eps: '更新至 第 12 集', extra: '高清线路 · 4K 原片', quality: '推荐画质', live: '极清' },
  { name: '《星海回响》第三季', eps: '更新至 第 07 集', extra: '高清线路 · 杜比音效', quality: '推荐画质', live: '极清' },
  { name: '《归途》特别篇', eps: '全 2 集', extra: '高清线路 · HDR 片源', quality: '推荐画质', live: '极清' },
  { name: '《无人的列车》', eps: '更新至 第 05 集', extra: '高清线路 · 剧场规格', quality: '推荐画质', live: '极清' },
];

export const newsItems = [
  { time: '21:12', date: '09-07', tone: 'bg-orange-500', dotClass: 'bg-orange-500', type: '更新', title: '《长街灯》第六季全篇上线，观看顺序表已同步更新到最新集', sub: '原 21 集步骤扩充至 24 集，番外插入位置微调' },
  { time: '18:40', date: '09-07', tone: 'bg-teal-500', dotClass: 'bg-teal-500', type: '换源', title: '《白夜回声》第 9 集换用流畅线路，缓冲问题解决', sub: '高峰期掉帧明显，建议优先走刚更新的这条' },
  { time: '15:02', date: '09-07', tone: 'bg-rose-500', dotClass: 'bg-rose-500', type: '上新', title: '《夏末信笺》开启高清线路，4K 片源逐集补齐', sub: '标清流畅线路仍保留，作为低设备备用' },
  { time: '22:31', date: '09-06', tone: 'bg-amber-500', dotClass: 'bg-amber-500', type: '归档', title: '《星海回响》时间线顺序重排完成，推荐路线已置顶', sub: '按事件发生顺序重建，乱序新人也能顺畅观看' },
  { time: '19:17', date: '09-06', tone: 'bg-emerald-500', dotClass: 'bg-emerald-500', type: '修复', title: '《归途》外传 4 处卡顿线路已修复', sub: '旧源失效替换，流畅线路整体更稳' },
  { time: '11:05', date: '09-06', tone: 'bg-orange-500', dotClass: 'bg-orange-500', type: '预告', title: '《雾港》第六季确认秋季回归，观看顺序将提前整理', sub: '会同步开坑，无需担心季与季之间的衔接' },
];

export const forumThreads = [
  { board: '求教', boardClass: 'bg-teal-100 text-teal-700', title: '第一次看《长街灯》，前传能跳过吗？会不会被剧透大结局？', by: '冬眠的鱼', reply: 87, like: 320 },
  { board: '讨论', boardClass: 'bg-orange-100 text-orange-700', title: '高清线路和流畅线路在长镜头上差距真的很大，你们都用哪条？', by: '熬夜的灯', reply: 143, like: 512 },
  { board: '整理', boardClass: 'bg-amber-100 text-amber-700', title: '整理了一份《星海回响》无剧透时间线，欢迎按顺序开刷', by: '拼图手残', reply: 66, like: 1088 },
  { board: '反馈', boardClass: 'bg-rose-100 text-rose-700', title: '今晚 20 点后《白夜回声》有点卡，是不是换源后没生效？', by: '回响听众', reply: 35, like: 94 },
  { board: '推荐', boardClass: 'bg-emerald-100 text-emerald-700', title: '补完《归途》后接哪部最顺？想找人列个推荐路线', by: '站台旅人', reply: 51, like: 201 },
  { board: '攻略', boardClass: 'bg-sky-100 text-sky-600', title: '《雾港》每季独立也能连看，季内顺序我标了个避坑版', by: '季末闲人', reply: 42, like: 176 },
];

export const rankList = [
  { rank: 1, title: '《长街灯·终章》', tag: '高清线路', move: 'up', delta: '+2', heat: '98.6' },
  { rank: 2, title: '《白夜回声》', tag: '流畅线路', move: 'up', delta: '+1', heat: '92.4' },
  { rank: 3, title: '《夏末信笺》', tag: '高清线路', move: 'same', delta: '持平', heat: '88.1' },
  { rank: 4, title: '《星海回响》第三季', tag: '流畅线路', move: 'down', delta: '-1', heat: '81.7' },
  { rank: 5, title: '《雾港》刑侦 第五季', tag: '流畅线路', move: 'up', delta: '+3', heat: '76.9' },
  { rank: 6, title: '《邻家星光》', tag: '高清线路', move: 'down', delta: '-1', heat: '70.2' },
];

export const topics = [
  { name: '悬疑刑侦', emoji: 'ri-user-search-line', tagClass: 'text-orange-600 bg-orange-100' },
  { name: '青春恋爱', emoji: 'ri-heart-3-line', tagClass: 'text-rose-600 bg-rose-100' },
  { name: '热血冒险', emoji: 'ri-fire-line', tagClass: 'text-amber-600 bg-amber-100' },
  { name: '科幻幻想', emoji: 'ri-planet-line', tagClass: 'text-teal-600 bg-teal-100' },
  { name: '日常治愈', emoji: 'ri-sun-line', tagClass: 'text-emerald-600 bg-emerald-100' },
  { name: '单元群像', emoji: 'ri-group-line', tagClass: 'text-indigo-600 bg-indigo-100' },
];

export const faqs = [
  { q: '「流畅线路」和「高清线路」到底怎么选？', a: '优先看设备与网速：追求不卡顿、秒开体验就选流畅线路；电视或大屏、对画质有要求就切高清线路。每部剧的两条线都会同时挂出，可随时切换，不影响观看进度。' },
  { q: '观看顺序是不是等于「播放顺序」？', a: '不完全是。播放顺序只决定你从哪一集点起，观看顺序则帮你避开剧透、把番外与剧场版放在合适位置，属于「推荐路线」的一部分。顺序表和线路是两套整理，互相独立。' },
  { q: '为什么有些路线当天不可用？', a: '部分线路属于备用源，高峰期或版权方调整时会临时下线。页面上会标注「已修复」「补档」状态，建议优先选择带「推荐路线」标签的条目，其余备源会尽快恢复。' },
  { q: '顺序表多久更新一次？', a: '新一集上线当天即同步；多部连更时，团队会按更新时间错峰整理。遇到剧情出现明显时间跳跃，也会追加无剧透补充说明，保证观看顺序始终贴合最新进度。' },
];

export const noticeTicker = [
  '《长街灯·终章》大结局高清线路已就绪',
  '今晚 22:00 起《白夜回声》启用备用流畅线路',
  '观看顺序表本周已更新 4 份，含 2 部剧场版补位',
  '社区整理了《雾港》季与季之间的衔接避雷',
];